import { onMounted, onUnmounted, toRefs, reactive } from 'vue'

/**
 * 鼠标移动多少时间后隐藏鼠标
 * @param delay 鼠标移动多少时间后隐藏鼠标，单位毫秒
 */
export default function useMouseHide(delay = 3000) { 
    const state = reactive({
        isMouseHidden: true,
    })
    let timer: number | undefined = undefined

    const handleActivity = () => {
        if(!state.isMouseHidden) return;
        state.isMouseHidden = false;
        clearTimeout(timer);
        timer = setTimeout(() => {
          state.isMouseHidden = true;
        }, delay);
    };

    const handleMouseEnter = () => {
        // 当鼠标进入窗口时，立即显示指针并重置计时器
        handleActivity();
    };

    // 添加多种事件监听
    const startListening = () => {
        window.addEventListener('mousemove', handleActivity);// 触摸屏支持
        window.addEventListener('mouseenter', handleMouseEnter);
        window.addEventListener('focus', handleFocusChange);
    };

    // 移除事件监听
    const stopListening = () => {
        window.removeEventListener('mousemove', handleActivity);
        window.removeEventListener('mouseenter', handleMouseEnter);
        window.removeEventListener('focus', handleFocusChange);
    };

    // 添加窗口焦点变化监听
    const handleFocusChange = () => {
        if (document.hasFocus()) {
            handleActivity(); // 窗口获得焦点时重置计时器
        }
    };


    onMounted(() => {
        startListening();
        handleActivity(); // 初始化鼠标活动
    })
    onUnmounted(() => {
        stopListening();
        window.removeEventListener('focus', handleFocusChange);
        clearTimeout(timer);
    })

    return { ...toRefs(state) }
}